import axioApi, { setHeader } from 'api/root.api';

export const getProject = async (token)=>{
    const urlEnd = '/editor/project/v3/list?size=1000';
    // setHeader('Access-Control-Allow-Origin', '*');
    setHeader('Authorization', `Bearer ${token}`);
    const response = await axioApi.get(urlEnd);
    const result = response.data;
    return result;
};